import React from 'react';

// Copied from apps/office/src/components/resource-details/custom/icons/LockerIcon.tsx
// so search rows match the locker glyph rendered on the map.
export const LockerIcon = ({
  color = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) => (
  <svg width="15" height="15" fill="none" viewBox="0 0 16 16" {...props}>
    <g fill={color}>
      {/* eslint-disable-next-line max-len */}
      <path d="M2.857 2.667c-.473 0-.857.398-.857.889v8.889c0 .49.384.889.857.889H5.43v-2.667h-1.5a.22.22 0 0 1-.215-.222V9.11c0-.122.096-.222.215-.222h1.5V2.667zM6.286 2.667v10.667h3.428v-2.667h-1.5A.22.22 0 0 1 8 10.445V9.11c0-.122.096-.222.214-.222h1.5V2.667zM10.571 2.667v10.667h2.572c.473 0 .857-.398.857-.89v-1.777h-1.5a.22.22 0 0 1-.214-.222V9.11c0-.122.096-.222.214-.222H14V3.556c0-.491-.384-.889-.857-.889z" />
    </g>
  </svg>
);
